import { Component, ElementRef, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MessService } from '../mess.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-add-item-dialog',
  templateUrl: './add-item-dialog.component.html',
  styleUrls: ['./add-item-dialog.component.scss']
})
export class AddItemDialogComponent {

  searchText = '';
  results: any[] = [];
  isLoading = false;
  errorMessage = '';
  private searchTimer: any;

  @ViewChild('searchInput') searchInput!: ElementRef<HTMLInputElement>;

  constructor(
    private dialogRef: MatDialogRef<AddItemDialogComponent>,
    private service: MessService,
    private spinner: NgxSpinnerService,
    @Inject(MAT_DIALOG_DATA) public data: { buildingId: any, existingItems: any[] },
  ) { }

  ngAfterViewInit(): void {
    setTimeout(() => this.searchInput?.nativeElement?.focus(), 0);
  }

  onSearchChange(value: string): void {
    this.searchText = value ?? '';
    this.errorMessage = '';

    if (this.searchTimer) clearTimeout(this.searchTimer);
    this.searchTimer = setTimeout(() => this.searchItems(), 300);
  }

  private searchItems(): void {
    const q = (this.searchText ?? '').trim();
    if (!q) {
      this.results = [];
      this.errorMessage = '';
      return;
    }
    // ✅ Call API only when 3+ characters entered
    if (q.length < 3) {
      this.results = [];
      this.isLoading = false;
      this.spinner.hide();
      return;
    }
    this.spinner.show();
    this.isLoading = true;
    this.service.itemSearch(this.data?.buildingId, q).subscribe({
      next: (res: any) => {
        this.results = Array.isArray(res) ? res : (res?.data ?? []);
        this.isLoading = false;
        this.spinner.hide();
      },
      error: () => {
        this.results = [];
        this.isLoading = false;
        this.spinner.hide();
      },
    });
  }

  selectItem(item: any): void {
    this.errorMessage = '';

    // ✅ Check duplicate here — dialog stays open
    const isDuplicate = this.data?.existingItems?.some(
      (x: any) => x?.itemId === item?.itemId
    );
    if (isDuplicate) {
      this.errorMessage = 'Item already exists.'; // ✅ show error in dialog
      return; // ✅ dialog does NOT close
    }

    const openBal = Number(item?.openBalance ?? 0);
    if (!openBal) {
      this.errorMessage = 'Open Balance is zero.';
      return;
    }
    this.dialogRef.close(item);
  }

  close(): void {
    this.dialogRef.close();
  }

  onImageError(event: any) {
    event.target.style.display = 'none'; // ✅ hide broken image
  }

}
